import {
  AppConfig,
  AppRouteObject,
  managementApi,
  matchTrackerApi,
  reportingApi
} from '@frontend/core'
import { eventsSlice } from '@frontend/core/lib/domains/events'
import { selectSelectedRegion } from '@frontend/core/lib/domains/regions'
import { useAppDispatch, useAppSelector } from '@frontend/react'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

// This hook generates breadcrumbs based on the current URL path and the app's route configuration. //
export function useBreadcrumbs(
  appConfig: AppConfig,
  selectedRoute: AppRouteObject
) {
  const location = useLocation()
  const pathname = location.pathname
  const segments = pathname.split('/').filter(Boolean)

  const entityKey = selectedRoute?.entityKey

  const breadcrumbs: { name: string; path: string }[] = []
  let pathAccumulator = ''

  // useEntityName(entityKey, '2174')

  segments.forEach((segment, index) => {
    pathAccumulator += `/${segment}`

    const matchedRoute = appConfig.routes.find((route) => {
      const routeSegments = route.path?.split('/').filter(Boolean) ?? []
      if (routeSegments.length !== index + 1) return false

      return routeSegments.every((seg, i) => {
        return seg.startsWith(':') || seg === segments[i]
      })
    })

    if (matchedRoute) {
      let displayName = matchedRoute.name

      // Handle dynamic segment with entity lookup
      const dynamicIndex =
        matchedRoute.path?.split('/').findIndex((seg) => seg.startsWith(':')) ??
        -1

      const entityNameAccessor = matchedRoute.entityNameAccessor

      if (dynamicIndex !== -1 && entityKey && segments[dynamicIndex - 1]) {
        const entityId = segments[dynamicIndex - 1]

        const entity = null

        if (entity) {
          const resolvedName = entityNameAccessor?.(entity)
          if (resolvedName) displayName = resolvedName
        }
      }

      breadcrumbs.push({
        name: displayName,
        path: pathAccumulator
      })
    }
  })

  return breadcrumbs
}

export function useRegionSwitchHandler() {
  const dispatch = useAppDispatch()

  const region = useAppSelector(selectSelectedRegion)

  const previousRegion = useRef(region)

  useEffect(() => {
    if (region && region !== previousRegion.current) {
      previousRegion.current = region

      // Reset relevant slices on region change //
      dispatch(matchTrackerApi.util.resetApiState())
      dispatch(managementApi.util.resetApiState())
      dispatch(reportingApi.util.resetApiState())
      dispatch(eventsSlice.actions.removeAll())
    }
  }, [dispatch, region])
}
